<div ng-controller="workflowConfigGeneralController as wfConfigGenCtrl" class="workflow-config-general-controller">
    <c-auto-form config="wfConfigGenCtrl.autoFormConfig"></c-auto-form>
</div>